/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import ReactTable from "react-table";
import InfiniteScroll from "react-infinite-scroll-component";
import PropTypes from "prop-types";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";
import moment from "moment";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import config from "../../../config";

export default class SalesRepDigitalCollections extends React.Component {
    static propTypes = {
        collections: PropTypes.object.isRequired,
    };

    state = {
        key: 2
    };

    render() {
        const columns = [
            {
                Header: "Title",
                accessor: "collection.title",
                sortable: true,
                Cell: row => {
                    return (<div>
                        {
                            row.original.productDeliveryType === "collections" ?
                                <a href={formatUrl(config.legacyAdmin.baseUrl, config.legacyAdmin.routes.digital,{
                                    collectionId: row.original.collection.collectionId,
                                    status: row.original.collection.status
                                })}>{row.original.collection.title}</a> : row.original.productDeliveryType === "custom-eText" ? 
                                    <a href={formatUrl(config.digitalAdmin.baseUrl, row.original.collection.collectionId)}>{row.original.contractedTitle}</a> :
                                    <a href={formatUrl(config.digitalAdmin.baseUrl, row.original.collection.collectionId)}>{row.original.contractedTitle}</a>
                        }
                    </div>);
                }
            },
            {
                Header: "Submitted",
                accessor: "createDate",
                Cell: row => {
                    return (<span>
                        {row.original.createDate ? moment(row.original.createDate)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,
            },
            {
                Header: "ISBN",
                accessor: "customISBN.isbn",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.customISBN.isbn}</div>
                        <div>{row.original.customISBN13}</div>
                    </div>);
                }
            },
            {
                Header: "Institution Name",
                accessor: "InstitutionName",
                Cell: row => {
                    return (<span>
                        {row.original.school})
                    </span>);
                },
                sortable: true,
            },
            {
                Header: "Adopter",
                accessor: "adopterFirstName",
                sortable: true,
                Cell: row => {
                    return (<div>
                        <div>{row.original.adopterFirstName + " " + row.original.adopterLastName}</div>
                    </div>);
                }
            },
            {
                Header: "Market",
                accessor: "collection.geo.code",
                sortable: true,
                width: 75
            },
            {
                Header: "Course Start Date ",
                accessor: "classStart",
                Cell: row => {
                    return (<span>
                        {row.original.classStart ? moment(row.original.classStart)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,

            },
            {
                Header: "Course End Date",
                accessor: "classStart",
                Cell: row => {
                    return (<span>
                        {row.original.classStart ? moment(row.original.classStart)
                            .format("MM/DD/YY") : ""}
                    </span>);
                },
                sortable: true,

            },
            {
                Header: "ExpectedEnrollment",
                id:"saleableQty",
                accessor: d =>
                    Number.parseInt(d.saleableQty, 10),
                sortable: true,
                width: 75
            },
            {
                Header: "Price",
                accessor: "collection.priceModel.totalPrice",
                sortable: true,
                width: 75
            },
            
        ];
        return (
            <div className="digital-collection-container">
                <h2>Digital Collections</h2>
                <div className="pe-row">
                    <div className="pe-col-12 pt-4">
                        {this.props.collections.totalItems > 0 && (
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={
                                        this.props.collections.items.length
                                    }
                                    next={this.props.loadMore}
                                    hasMore={this.props.hasMore}
                                    loader={<LoadingIndicator/>}
                                    scrollableTarget="scrollTable"
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={
                                                this.props.collections.items
                                            }
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={
                                                this.props.collections.totalItems
                                            }
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText="No batch details found"
                                            onSortedChange={() => {
                                                this.setState({ key: Math.random() });
                                            }}
                                            getTrProps={() => {
                                                return {
                                                    style: {
                                                        textAlign: "center",
                                                    }
                                                };
                                            }}
                                        />
                                    </div>
                                </InfiniteScroll>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/SaleRepCapabilities/SalesRepDigitalCollections.js